import elo from "../assets/bandeiras/elo.svg";
import hipercard from "../assets/bandeiras/hipercard.jpg";
import maestro from "../assets/bandeiras/maestro.jpg";
import mastercard from "../assets/bandeiras/mastercard.svg";
import visa from "../assets/bandeiras/visa.svg";

export const BRANDS = [
	// VISA
	{
		id: "visa",
		name: "Visa",
		img: visa,
		test: (v) => /^4\d{0,15}$/.test(v),
		lengths: [13, 16, 19],
	},

	// MASTERCARD
	{
		id: "mastercard",
		name: "Mastercard",
		img: mastercard,
		test: (v) => /^(5[1-5]\d{0,14}|2(2[2-9]\d{0,12}|[3-6]\d{0,13}|7[01]\d{0,12}|720\d{0,12}))$/.test(v),
		lengths: [16],
	},

	// ELO (muitos prefixos que se sobrepõem, deve vir antes de Hipercard/Maestro)
	{
		id: "elo",
		name: "Elo",
		img: elo,
		test: (v) =>
			/^(4011(78|79)|431274|438935|451416|457393|504175|627780|636297|636368|650\d{2}|65165[2-9]|6516[6-7]\d|6550\d{2})/.test(
				v
			),
		lengths: [16],
	},

	// HIPERCARD (prefixos específicos e curtos — deve vir antes do Maestro)
	{
		id: "hipercard",
		name: "Hipercard",
		img: hipercard,
		test: (v) => /^(606282|3841[046])/.test(v),
		lengths: [13, 16, 19],
	},

	// MAESTRO (colocar por último — prefixos amplos e facilmente conflitantes)
	{
		id: "maestro",
		name: "Maestro",
		img: maestro,
		test: (v) => /^(5018|5020|5038|5893|6304|6759|6761|6762|6763)/.test(v),
		lengths: [12, 13, 14, 15, 16, 17, 18, 19],
	},
];

export const formatCardNumberSpaces = (v) =>
	v
		.replace(/\D/g, "")
		.replace(/(.{4})/g, "$1 ")
		.trim();
